import apiClient from "./axios";

export interface RegisterPayload {
  email: string;
  username: string;
  password: string;
}

export interface LoginPayload {
  email: string;
  password: string;
  remember_me?: boolean;
}

export const registerUser = async (payload: RegisterPayload) =>
  apiClient.post("/auth/register", payload);

export const loginUser = async (payload: LoginPayload) =>
  apiClient.post("/auth/login", payload);

export const forgotPassword = async (email: string) =>
  apiClient.post("/auth/forgot-password", { email });

export const resetPassword = async (token: string, newPassword: string) =>
  apiClient.post("/auth/reset-password", {
    token,
    new_password: newPassword,
  });

export const logoutUser = async (refreshToken?: string | null) =>
  apiClient.post("/auth/logout", { refresh_token: refreshToken ?? null });

export const getMe = async () => apiClient.get("/auth/me");
